var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.current_clinic && _vm.current_clinic.id == _vm.clinic_id)?_c('div',[_c('UserNewSubscription',{attrs:{"current_clinic":_vm.current_clinic}})],1):_c('div',[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }